import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const FontPreview = () => {
  const [searchParams] = useSearchParams();
  const fontUrl = searchParams.get('font_url');
  const text = searchParams.get('text');
  const [fontLoaded, setFontLoaded] = useState(false);
  const [fontError, setFontError] = useState(false);
  const [fontFamilyName, setFontFamilyName] = useState('');

  useEffect(() => {
    if (!fontUrl) return;

    // Create a unique font family name based on the URL
    const fontFamilyName = `CustomFont_${Date.now()}`;

    // Create a new font face
    const fontFace = new FontFace(fontFamilyName, `url(${fontUrl})`);

    document.body.style.backgroundColor = 'transparent';

    // Load the font
    fontFace.load()
      .then((loadedFont) => {
        // Add the font to the document
        document.fonts.add(loadedFont);
        setFontLoaded(true);
        setFontError(false);
        setFontFamilyName(fontFamilyName);
      })
      .catch((error) => {
        console.error('Erro ao carregar fonte:', error);
        setFontError(true);
        setFontLoaded(false);
      });
  }, [fontUrl]);

  // Default text if none provided
  const displayText = text || 'Texto de exemplo para visualização da fonte';

  if (!fontUrl) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="text-center p-8">
          <h1 className="text-2xl font-bold text-gray-900 mb-4">
            Visualizador de Fonte
          </h1>
          <p className="text-gray-600 mb-4">
            Para usar esta página, adicione os parâmetros de consulta:
          </p>
          <div className="bg-gray-100 p-4 rounded-lg font-mono text-sm">
            ?font_url=URL_DA_FONTE&text=TEXTO_PARA_VISUALIZAR
          </div>
          <p className="text-gray-500 mt-4 text-sm">
            Exemplo: ?font_url=https://fonts.gstatic.com/s/roboto/v30/KFOmCnqEu92Fr1Mu4mxK.woff2&text=Olá Mundo
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="w-full max-w-4xl text-center">
        {fontError && (
          <div className="mb-8 p-4 bg-red-50 border border-red-200 rounded-lg">
            <p className="text-red-700">
              Erro ao carregar a fonte. Verifique se a URL está correta e se a fonte está acessível.
            </p>
          </div>
        )}

        <div
          id="preview-text-black"
          data-loaded={fontLoaded ? 'true' : 'false'}
          className="text-6xl leading-tight p-2"
          style={{
            display: 'inline-block',
            color: '#000',
            whiteSpace: 'nowrap',
            hyphens: 'auto',
            fontFamily: fontFamilyName,
          }}
        >
          {displayText}
        </div>
        <div
          id="preview-text-white"
          data-loaded={fontLoaded ? 'true' : 'false'}
          className="text-6xl leading-tight p-2"
          style={{
            display: 'inline-block',
            color: '#fff',
            whiteSpace: 'nowrap',
            hyphens: 'auto',
            fontFamily: fontFamilyName,
          }}
        >
          {displayText}
        </div>

        {!fontLoaded && !fontError && (
          <div className="mt-8">
            <div className="inline-flex items-center px-4 py-2 bg-blue-50 rounded-lg">
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-500 mr-2"></div>
              <span className="text-blue-700 text-sm">Carregando fonte...</span>
            </div>
          </div>
        )}

        {fontLoaded && (
          <div className="mt-8 text-sm text-gray-500">
            Fonte carregada com sucesso
          </div>
        )}
      </div>
    </div>
  );
};

export default FontPreview;
